import {WalkthroughId} from './types';

type WalkthroughEvent = 'started' | 'step_viewed' | 'completed' | 'skipped' | 'target_missing';

interface BaseProperties {
  walkthroughId: WalkthroughId;
  version: number;
}

interface StepProperties extends BaseProperties {
  stepIndex: number;
  totalSteps: number;
}

type EventProperties = BaseProperties | StepProperties;

export const trackWalkthroughEvent = (event: WalkthroughEvent, properties: EventProperties): void => {
  window.posthog?.capture(`walkthrough:${event}`, properties);
};
